module.exports = __webpack_public_path__ + "static/media/r7s3.7456d1b1.jpg";